import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Euro, Briefcase, ShoppingBag } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function ClassifiedsWidget() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const load = () => fetch(`${API}/public/classifieds?status=approved&limit=4`).then(r => r.json()).then(d => setItems(d.classifieds || d.items || [])).catch(() => {});
    load();
    const iv = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(iv);
  }, []);
  if (items.length === 0) return null;
  return (
    <div className="bg-white dark:bg-[#0f172a] rounded-xl p-5 border border-gray-100 dark:border-gray-800" data-testid="classifieds-widget">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-bold uppercase tracking-wider text-gray-900 dark:text-gray-100 border-l-4 border-amber-500 pl-3 flex items-center gap-1.5"><ShoppingBag size={12} /> OGLASNIK</h3>
        <Link to="/oglasnik" className="text-[10px] text-red-600 dark:text-red-400 font-medium">Vidi sve →</Link>
      </div>
      <div className="space-y-2.5">
        {items.slice(0, 4).map(c => (
          <Link to={`/oglasnik/${c.id}`} key={c.id} className="flex gap-2.5 group" data-testid={`classified-${c.id}`}>
            {c.cover_image_url ? (
              <div className="w-14 h-14 shrink-0 rounded-md overflow-hidden bg-gray-100 dark:bg-[#111827]">
                <img src={c.cover_image_url} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
              </div>
            ) : (
              <div className="w-14 h-14 shrink-0 rounded-md bg-amber-50 dark:bg-amber-900/20 flex items-center justify-center text-amber-500"><ShoppingBag size={18} /></div>
            )}
            <div className="min-w-0 flex-1">
              <h4 className="text-xs font-bold text-gray-800 dark:text-gray-100 group-hover:text-red-600 line-clamp-2 leading-snug">{c.title}</h4>
              <div className="flex items-center gap-2 mt-1 text-[10px] text-gray-500 dark:text-gray-400">
                {c.price != null && <span className="font-semibold text-amber-600 dark:text-amber-400 flex items-center gap-0.5"><Euro size={9} />{c.price}</span>}
                {c.location && <span className="flex items-center gap-0.5 truncate"><MapPin size={9} />{c.location}</span>}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function JobsWidget() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const load = () => fetch(`${API}/public/jobs?status=active&limit=3`).then(r => r.json()).then(d => setItems(d.jobs || d.items || [])).catch(() => {});
    load();
    const iv = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(iv);
  }, []);
  if (items.length === 0) return null;
  return (
    <div className="bg-white dark:bg-[#0f172a] rounded-xl p-5 border border-gray-100 dark:border-gray-800" data-testid="jobs-widget">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-bold uppercase tracking-wider text-gray-900 dark:text-gray-100 border-l-4 border-emerald-500 pl-3 flex items-center gap-1.5"><Briefcase size={12} /> POSAO</h3>
        <Link to="/posao" className="text-[10px] text-red-600 dark:text-red-400 font-medium">Vidi sve →</Link>
      </div>
      <div className="space-y-2.5">
        {items.slice(0, 3).map(j => (
          <Link to={`/posao/${j.id}`} key={j.id} className="block group" data-testid={`job-${j.id}`}>
            <h4 className="text-xs font-bold text-gray-800 dark:text-gray-100 group-hover:text-red-600 line-clamp-2 leading-snug">{j.title}</h4>
            <div className="flex items-center gap-2 mt-1 text-[10px] text-gray-500 dark:text-gray-400">
              {j.company && <span className="font-semibold text-emerald-600 dark:text-emerald-400">{j.company}</span>}
              {j.location && <span className="flex items-center gap-0.5"><MapPin size={9} />{j.location}</span>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
